import { useQuery } from "@tanstack/react-query";
import { getTicketAreas } from "@/shared/actions/campanas/migracion.actions";

export interface TicketArea {
  id_area: string;
  codigo: string;
  numero_referencia?: string;
  nombre: string;
  descripcion?: string;
  color?: string;
  activa?: boolean;
  orden?: number;
  estado?: boolean;
  fecha_creacion?: string;
  fecha_modificacion?: string;
}

export interface TicketAreasResponse {
  code: number;
  status: string;
  data: TicketArea[];
}

export const useTicketAreas = () => {
  const query = useQuery<TicketAreasResponse>({
    queryKey: ["ticket-areas"],
    queryFn: async () => {
      // getTicketAreas devuelve ApiResponse<PageResponse<TicketAreaResponse>>.
      // Adaptamos a la forma simple { code, status, data: TicketArea[] } que
      // espera el resto del componente, mapeando .data.content -> .data.
      // Cast a unknown primero para que TS acepte el cambio de shape (tipos
      // no se solapan suficiente y un cast directo dispara TS2352).
      const response: any = await getTicketAreas();
      const items: TicketArea[] = response?.data?.content ?? response?.data ?? [];
      return {
        code: response?.code ?? 200,
        status: response?.status ?? "success",
        data: items,
      };
    },
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    loading: query.isLoading,
    refetch: query.refetch,
  };
};